/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';


const {state} = store('gt-menu-burger', {
	state: {
		isOpen: false,
	},
	actions: {
		closeMenu: () => {
			state.isOpen = false;
			document.body.classList.remove('gt-menu-burger-open');
		},
		toggle: () => {
			state.isOpen = !state.isOpen;
			const element = getElement();

			if (state.isOpen) {
				document.body.classList.add('gt-menu-burger-open');

				setTimeout(() => {
					const wrap = element.ref.closest('.wp-block-gt-gt-menu-burger').querySelector('.gt-menu-burger-content');
					const focusableElements = 'a, button, input, textarea, select';
					const firstFocusableElement = wrap.querySelectorAll(focusableElements)[0];
					firstFocusableElement.focus();
				}, 10);

			
			} else {
				document.body.classList.remove('gt-menu-burger-open');
				setTimeout(() => {
					element.ref.closest('.wp-block-gt-gt-menu-burger').querySelector('.gt-menu-burger-toggle').focus();
				}, 10);

			}
			
		},
		outsideClick: (e) => {
			if(!state.isOpen) return;

			const el = getElement();
			const parentElements = document.querySelectorAll('header'); // Remplacez par la classe de l'élément parent
			const menu = el.ref;
			let isClickInside = false;

			parentElements.forEach((parentElement) => {
				if (menu && (menu.contains(e.target) || parentElement.contains(e.target))) {
					isClickInside = true;
				}
			});

			if (!isClickInside) {
				state.isOpen = false;
				document.body.classList.remove('gt-menu-burger-open');
				setTimeout(() => {
					document.querySelector('.gt-menu-burger-toggle').focus();
				}, 10);
			}

		}
	},
	callbacks: {
		focusTrap: (e) => {
			const wrap = document.querySelector('.gt-menu-burger-content');
			const focusableElements = 'a, button, input, textarea, select';
			const firstFocusableElement = wrap.querySelectorAll(focusableElements)[0];
			const focusableContent = wrap.querySelectorAll(focusableElements);
			const lastFocusableElement = focusableContent[focusableContent.length - 1];

			let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
			let isEscPressed = e.key === 'Escape' || e.keyCode === 27;

			if (!isTabPressed && !isEscPressed) {
				return;
			}

			if (isEscPressed) {
				state.isOpen = !state.isOpen;
				document.body.classList.remove('gt-menu-burger-open');
				setTimeout(() => {
					document.querySelector('.gt-menu-burger-toggle').focus();
				}, 10);
				return;
			}

			if (e.shiftKey) {
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus();
					e.preventDefault();
				}
			} else {
				if (document.activeElement === lastFocusableElement) {
					firstFocusableElement.focus();
					e.preventDefault();
				}
			}
		},
	},
});
